module.exports = "/assets/fadd96a8205771cc3d18c5e2c7cf86e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/9W.png
// module id = 1175
// module chunks = 0